export function createEmpleadoIdentificacionTipo() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Descripcion: '',
    Orden: 0,
    EsSistema: false,
    EsActivo: true
  };
}

